import { ApplicationRef, DoBootstrap, inject, NgModule, provideAppInitializer } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { ExternalLoginErrorComponent } from './app/external-login-error/external-login-error.component';
import { ForgotPasswordComponent } from './app/forgot-password/forgot-password.component';
import { LoginFormComponent } from './app/login-form/login-form.component';
import { LogoutComponent } from './app/logout/logout.component';
import { ResetPasswordComponent } from './app/reset-password/reset-password.component';
import { SsoButtonComponent } from './app/sso-button/sso-button.component';
import { SsoMaxSessionsComponent } from './app/sso-max-sessions/sso-max-sessions.component';
import { SsoOptionsComponent } from './app/sso-options/sso-options.component';
import { SsoVerifyAccountComponent } from './app/sso-verify-account/sso-verify-account.component';
import { TwoFactorSelectionComponent } from './app/two-factor-selection/two-factor-selection.component';
import { AuthenticatorComponent } from './app/two-factor-setup/authenticator/authenticator.component';
import { BeginEnrollmentComponent } from './app/two-factor-setup/begin-enrollment/begin-enrollment.component';
import { CompleteEnrollmentComponent } from './app/two-factor-setup/complete-enrollment/complete-enrollment.component';
import { EnrollmentOptionsComponent } from './app/two-factor-setup/enrollment-options/enrollment-options.component';
import { TypeEnrollmentComponent } from './app/two-factor-setup/type-enrollment/type-enrollment.component';
import { VerificationCodeComponent } from './app/two-factor-setup/verification-code/verification-code.component';
import { globals } from './globals';

// Any new components need to be added to the imports array to ensure they are included in the bundle.
// If they're not in imports, they will be tree-shaken out and won't be available to bootstrap on demand.
@NgModule({
  imports: [
    AuthenticatorComponent,
    BeginEnrollmentComponent,
    BrowserModule,
    CompleteEnrollmentComponent,
    EnrollmentOptionsComponent,
    ExternalLoginErrorComponent,
    ForgotPasswordComponent,
    LoginFormComponent,
    LogoutComponent,
    ResetPasswordComponent,
    SsoButtonComponent,
    SsoMaxSessionsComponent,
    SsoOptionsComponent,
    SsoVerifyAccountComponent,
    TwoFactorSelectionComponent,
    TypeEnrollmentComponent,
    VerificationCodeComponent,
  ],
  providers: [
    FormBuilder,
    provideAppInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      iconRegistry.setDefaultFontSetClass('material-symbols-outlined')
    }),
  ],
})
export class AppModule implements DoBootstrap {
  ngDoBootstrap(appRef: ApplicationRef): void {
    // The output JS is loaded on all pages, but each component only requires
    // bootstrapping if it is used on the page.
    if (globals.bootstrapLoginComponent) {
      appRef.bootstrap(LoginFormComponent);
    }

    if (globals.bootstrapSsoVerifyAccountComponent) {
      appRef.bootstrap(SsoVerifyAccountComponent);
    }

    if (globals.bootstrapSsoOptionsComponent) {
      appRef.bootstrap(SsoOptionsComponent);
    }

    if (globals.bootstrapExternalLoginErrorComponent) {
      appRef.bootstrap(ExternalLoginErrorComponent);
    }

    if (globals.bootstrapSsoMaxSessionsComponent) {
      appRef.bootstrap(SsoMaxSessionsComponent);
    }

    if (globals.bootstrapResetPasswordComponent) {
      appRef.bootstrap(ResetPasswordComponent);
    }

    if (globals.bootstrapForgotPasswordComponent) {
      appRef.bootstrap(ForgotPasswordComponent);
    }

    if (globals.bootstrapTwoFactorSelectionComponent) {
      appRef.bootstrap(TwoFactorSelectionComponent);
    }

    if (globals.bootstrapLogoutComponent) {
      appRef.bootstrap(LogoutComponent);
    }

    if (globals.bootstrapBeginEnrollmentComponent) {
      appRef.bootstrap(BeginEnrollmentComponent);
    }

    if (globals.bootstrapEnrollmentOptionsComponent) {
      appRef.bootstrap(EnrollmentOptionsComponent);
    }

    if (globals.bootstrapTypeEnrollmentComponent) {
      appRef.bootstrap(TypeEnrollmentComponent);
    }

    if (globals.bootstrapVerificationCodeComponent) {
      appRef.bootstrap(VerificationCodeComponent);
    }

    if (globals.bootstrapAuthenticatorComponent) {
      appRef.bootstrap(AuthenticatorComponent);
    }

    if (globals.bootstrapCompleteEnrollmentComponent) {
      appRef.bootstrap(CompleteEnrollmentComponent);
    }

    if (globals.bootstrapSsoButtonComponent) {
      appRef.bootstrap(SsoButtonComponent);
    }
  }
}
